import React, { useEffect } from 'react'
import { Modal } from 'react-bootstrap'
import { awaitDelay, dataTableLanguaje, globalSettings, isUndNullEmp, languageObjGet, numberSet, responseGet, sendMessageCloseCurrentWindowAsync, styles } from '../../helpers/settings';
import { GlobalFormats } from '../../classes/main/globalFormats';
import { apartmentModelGet } from '../../models/apartments/apartment';
import { buildingModelGet } from '../../models/buildings/building';

const currentMethod = 'ApartmentAliquoutPercentages';

const { colors, labels, icons, } = globalSettings;

export default function ApartmentAliquoutPercentages({
    $ = {},
    auth = {},
    processValues = {
        apartments: [apartmentModelGet({})],
        building: buildingModelGet({}),
        apartmentsDt: [],
        showModal: false,
        setShowModal: () => { },
    },
    languageObj = GlobalFormats?.class(languageObjGet({ subMethod: currentMethod, })?.result),
}) {
    //#region variables
    const dtAliquotsId = 'dtAliquots';
    //#region others
    const controls = {
        buttons: {
            back: {
                className: 'btn btn-outline-success btn-sm',
                id: 'btnModalApartmentAliquotPercentagesBack',
            },
            close: {
                className: 'close btn-danger fas fa-window-close',
                id: 'btnModalApartmentAliquotPercentagesClose',
            },
        },
        checkBox: {
            // remenberMe: {
            //     attributes: {
            //     },
            //     id: 'chkRemenberMe',
            // },
        },
        dataTables: {
            // buildings: {
            //     inputs: {
            //         search: {
            //             id: `${dtApartmentsId}_filter input`,
            //             className: '',
            //         },
            //     },
            //     selects: {
            //         entries: {
            //             id: `${dtApartmentsId}_length select`,
            //             className: '',
            //         },
            //     },
            // },
        },
        icons: {
            back: {
                id: 'iconModalApartmentAliquotPercentagesBack',
                className: icons?.arrowAltCircleLeft,
            },
        },
        inputs: {
            // email: {
            //     id: 'inputEmail',
            // },
            // password: {
            //     id: 'inputPassword',
            // },
        },
        spinners: {
            back: {
                id: 'spModalApartmentAliquotPercentagesBack',
                className: '',
            }
        },
        urls: {
            // forgotYourPassword: {
            //     id: 'urlForgotYourPassword',
            //     className: 'btn-link',
            // },
            // reCaptchaPrivaciConditions: {
            //     id: 'urlReCaptchaPrivaciConditions',
            //     className: '',
            // },
            // userRegister: {
            //     id: 'urlRequestAccount',
            //     className: '',
            // },
            // registerStatus: {
            //     id: 'urlStatusRegister',
            //     className: '',
            // },
        },
    };
    //#endregion others
    //#endregion variables

    //#region process
    const defaultValueSetAsync = async ({ isModalClose = false, subMethod = '', }) => {
        const currentMethod = 'defaultValueSetAsync';
        let response = responseGet();
        try {
            if (isModalClose) {
                controlsStatusSet({ processType: 1, subMethod: currentMethod, });
                await awaitDelay({ delayTimer: globalSettings?.timers?.oneSecond, });
            }

            processValues?.setShowModal(!isModalClose);
            controlsStatusSet({ processType: 0, subMethod: currentMethod, });
        } catch (ex) {
            controlsStatusSet({ processType: 0, subMethod: currentMethod, });
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }

    const dataTablesSetAsync = async ({ subMethod = '', }) => {
        const currentMethod = 'dataTablesSetAsync';
        let response = responseGet();
        try {
            $(`#${dtAliquotsId}`)?.DataTable({
                //buttons: ['copy', 'csv', 'excel', 'pdf', 'print', 'colvis',],
                columns: [
                    { title: labels?.floor?.[languageObj?.id], visible: false, width: '0%', },
                    { title: labels?.identifier?.[languageObj?.id], width: '60%', },
                    // { title: `% ${labels?.aliquot?.[languageObj?.id]}`, className: 'text-right', width: '30%', },
                    {
                        title: `% ${labels?.aliquot?.[languageObj?.id]}`,
                        className: 'text-right',
                        width: '30%',
                        render: function (data, type, row) {
                            const dataObj = {
                                color: 'black',
                                value: data?.replaceAll(languageObj?.numbers?.separators?.thousands, ''),
                                data: '',
                            };
                            dataObj.value = languageObj?.numbers?.separators?.decimals === ',' ? dataObj?.value?.replaceAll(',', '.') : dataObj?.value;
                            dataObj.value = numberSet({
                                number: dataObj?.value,
                                type: 'd',
                                languageId: languageObj,
                                subMethod: currentMethod,
                            })?.result;

                            if (dataObj.value > 0.00) {
                                dataObj.color = colors?.successColorExp;
                                dataObj.data = `<span style='color:${dataObj.color};font-size:14px'><i class='${icons?.check}'></i>  ${data}%</span>`;
                            } else if (dataObj.value === 0.00) {
                                dataObj.color = colors?.warningColorExp;
                                dataObj.data = `<span style='color:${dataObj.color};font-size:14px'><i class='${icons?.caretRight}'></i>  ${data}%</span>`;
                            } else if (dataObj.value < 0.00) {
                                dataObj.color = colors?.dangerColorExp;
                                dataObj.data = `<span style='color:${dataObj.color};font-size:14px'><i class='${icons?.caretDown}'></i>  ${data}%</span>`;
                            }

                            return dataObj.data;
                        }
                    },
                ],
                autoWidth: false,
                data: [],
                destroy: true,
                info: false,
                language: dataTableLanguaje({ languageId: languageObj?.id, subMethod: currentMethod, }),
                //lengthChange: true,
                lengthChange: false,
                order: [[0, 'asc'], [1, 'asc']],
                responsive: true,
                searching: false,
                pageLength: 6,
                //}).buttons().container().appendTo(`#${dtApartmentsId}_wrapper .col-md-6:eq(0)`);
            });
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }

    const dataSetAsync = async ({ subMethod = '', }) => {
        const currentMethod = 'dataSetAsync';
        let response = responseGet();
        try {
            response = await dataTablesSetAsync({ subMethod: currentMethod, });
            if (!response?.isSuccess || response?.isWarning) {
                await defaultValueSetAsync({ isModalClose: true, subMethod: currentMethod, });
            }

            $(`#${dtAliquotsId}`)?.DataTable()?.rows?.add(processValues?.apartmentsDt)?.draw(true);
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
            await defaultValueSetAsync({ isModalClose: true, subMethod: currentMethod, });
        }
        return response;
    }

    const controlsStatusSet = ({ processType = 0, subMethod = '', }) => {
        let response = responseGet();
        const currentMethod = 'controlsStatusSet';
        try {
            //#region variables
            //#endregion variables

            //#region methods
            switch (processType) {
                case 0:
                    $(`#${controls?.icons?.back?.id}`)?.removeClass();
                    $(`#${controls?.buttons?.back?.id}`)?.removeClass();
                    $(`#${controls?.spinners?.back?.id}`)?.removeClass();

                    $(`#${controls?.buttons?.close?.id}`)?.removeClass();

                    $(`#${controls?.icons?.back?.id}`)?.addClass(controls?.icons?.back?.className);
                    $(`#${controls?.buttons?.back?.id}`)?.addClass(controls?.buttons?.back?.className);
                    $(`#${controls?.spinners?.back?.id}`)?.addClass(controls?.spinners?.back?.className);

                    $(`#${controls?.buttons?.close?.id}`)?.addClass(controls?.buttons?.close?.className);
                    break;
                case 1:
                    //$(`#${controls?.buttons?.back?.id}`)?.addClass(`${globalSettings?.react?.html?.button?.classes?.disabled} ${settings.react.html.button.classes.progress}`);
                    $(`#${controls?.icons?.back?.id}`)?.removeClass();
                    $(`#${controls?.spinners?.back?.id}`)?.addClass(`${globalSettings?.react?.html?.spinner?.borderSm}`);
                    break;
                default:
                    break;
            }

            //#region old code
            // $(`#${controls?.inputs?.email?.id}`).attr('readOnly', (processType !== 0));
            // $(`#${controls?.inputs?.password?.id}`).attr('readOnly', (processType !== 0));
            // $(`#${controls?.checkBox?.remenberMe?.id}`).attr('disabled', (processType !== 0));
            //#endregion old code

            //#region old code
            // $(`#${controls?.urls?.forgotYourPassword?.id}`).attr('href', (processType !== 0 ? urlStop : globalSettings?.app?.backend?.urlForgotPassword));
            // $(`#${controls?.urls?.userRegister?.id}`).attr('href', (processType !== 0 ? urlStop : globalSettings?.app?.backend?.urlUserRegister));
            // $(`#${controls?.urls?.registerStatus?.id}`).attr('href', (processType !== 0 ? urlStop : globalSettings?.app?.backend?.urlRegisterStatus));
            //#endregion old code

            //#region old code
            // $(`#${controls?.urls?.reCaptchaPrivaciConditions?.id}`).attr('href', (processType !== 0 ? urlStop : globalSettings?.react?.reCAPTCHA?.urlPrivaciConditions));
            // $(`#${controls?.urls?.reCaptchaPrivaciConditions?.id}`).attr('target', (processType !== 0 ? '' : '_blank'));
            //#endregion old code

            //#region old code
            // $(`#${controls?.urls?.reCaptchaPrivaciConditions?.id}`).attr({
            //     'href': (processType !== 0 ? urlStop : globalSettings?.app?.reCAPTCHA?.urlPrivaciConditions),
            //     'target': (processType !== 0 ? '' : '_blank'),
            // });
            //#endregion old code

            //#region dataTable buttons
            // btnExcel.node.disabled = processType !== 0;
            // btnPdf.node.disabled = processType !== 0;
            //#endregion dataTable buttons

            //#region old code
            // $(`#${controls?.dataTables?.buildings?.inputs?.search?.id}`)?.attr('readOnly', (processType !== 0));
            // $(`#${controls?.dataTables?.buildings?.selects?.entries?.id}`)?.attr('disabled', (processType !== 0));
            //#endregion old code

            if (processType !== 0) {
                $(`#${controls?.buttons?.close?.id}`)?.addClass(`${globalSettings?.react?.html?.button?.classes?.disabled}`);
                $(`#${controls?.buttons?.back?.id}`)?.addClass(globalSettings?.react?.html?.button?.classes?.disabled);
            }
            //#endregion methods
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
            console?.error(response);
        }
        return response;
    }

    useEffect(() => {
        dataSetAsync({ subMethod: 'form - onLoad', });
    }, []); // eslint-disable-line react-hooks/exhaustive-deps
    //#endregion process

    return (
        <Modal backdrop='static' show={processValues?.showModal} onHide={() => defaultValueSetAsync({ isModalClose: true, subMethod: 'modal - onHide', })}>
            <Modal.Header>
                <Modal.Title>
                    <img alt={labels?.aliquot?.[languageObj?.id]} src={globalSettings?.images?.aliquotPercentage} style={styles?.cardHeaderLogo}></img> - {labels?.assignedAliquots?.[languageObj?.id]}
                </Modal.Title>
                <button id={controls?.buttons?.close?.id}
                    className={controls?.buttons?.close?.className}
                    data-dismiss='modal'
                    aria-label='Close'
                    type='button'
                    onClick={() => defaultValueSetAsync({ isModalClose: true, subMethod: 'modal - btnHeader', })}>
                </button>
            </Modal.Header>
            <Modal.Body>
                <div className={globalSettings?.html?.dataTables?.formats?.tableResponsiveSm}>
                    <table id={dtAliquotsId} className={globalSettings?.html?.dataTables?.formats?.smStripedBordered} />
                </div>
            </Modal.Body>
            <Modal.Footer>
                <button id={controls?.buttons?.back?.id}
                    className={controls?.buttons?.back?.className}
                    onClick={() => defaultValueSetAsync({ isModalClose: true, subMethod: 'modal - btnFooter', })}
                    title={labels?.close?.[languageObj?.id]}>
                    <i id={controls?.icons?.back?.id} className={controls?.icons?.back?.className} /> <span id={controls?.spinners?.back?.id} className='' aria-hidden='true'></span>
                </button>

            </Modal.Footer>
        </Modal>
    )
}